// extracted by mini-css-extract-plugin
var _1 = "DocFlowSelectedAreaInfo-moduleDocFlowSelectedAreaInfo__dWCxF";
var _2 = "DocFlowSelectedAreaInfo-modulecontent__qaUv7";
var _3 = "DocFlowSelectedAreaInfo-modulecontentText__IpFPe";
var _4 = "DocFlowSelectedAreaInfo-modulenoDataContainer__cyYQ5";
var _5 = "DocFlowSelectedAreaInfo-modulescrollContent__cQwXl";
var _6 = "DocFlowSelectedAreaInfo-moduletitle__gwyAL";
export { _1 as "DocFlowSelectedAreaInfo", _2 as "content", _3 as "contentText", _4 as "noDataContainer", _5 as "scrollContent", _6 as "title" }
